export default __webpack_public_path__ + "static/media/user4.6ac95ef9.jpg";